import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules'

export default function setInstagram() {
    const instagramSwiper = new Swiper('[data-instagram-swiper]', {
        modules: [Navigation, Pagination],
        slidesPerView: 2.3,
        slidesPerGroup: 1,
        spaceBetween: 10,
        speed: 1000,
        breakpoints: {
            768: {
                slidesPerView: 4,
            },
            992: {
                slidesPerView: 6,
                spaceBetween: 0,
            },
        },
        pagination: {
            el: '[data-instagram-swiper] .swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
    });
}
